import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Cros3FormUI from "./Cros3FormUI";
import { createCros3Form } from "../../store/slices/cros3FormSlice";
import { fetchPatient } from "../../store/slices/patientsSlice";

const AddCros3Form = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { caseId, patientId } = state || {};

  const [formData, setFormData] = useState({
    patient_id: patientId || "",
    case_id: caseId || "",
    consumer_details: {
      month: "",
      day: "",
      year: "",
      organization_id: "1",
      agency_id: "",
      program_id: "",
      staff_id: "",
      help: "No",
      translated: "No",
    },
    consumer_responses: {},
    staff_details: {
      primary: "",
      secondary: "",
      tertiary: "",
      last_discharge: "",
      has_payee: "No",
      chronically_homeless: "No",
      new_to_agency: "No",
      new_to_agency_2: "No",
    },
    staff_responses: {},
    vip_details: {
      consumer_name: "",
      organization_id: "1",
      program_id: "",
      staff_id: "",
      agency_id: "",
      filled_date: new Date().toISOString().split("T")[0],
      relationship: "",
    },
    vip_responses: {},
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (patientId) {
      dispatch(fetchPatient(patientId))
        .unwrap()
        .then((patient) => {
          if (patient) {
            const fullName = `${patient.first_name || ""} ${patient.last_name || ""}`.trim();
            setFormData((prev) => ({
              ...prev,
              vip_details: {
                ...(prev.vip_details || {}),
                consumer_name: fullName,
              },
            }));
          }
        })
        .catch((err) => console.error("Failed to fetch patient details:", err));
    }
  }, [dispatch, patientId]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await dispatch(createCros3Form(formData)).unwrap();

      Swal.fire({
        title: "Success!",
        text: "CROS-3 Questionnaire added successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      navigate(`/phase03/cros3-form/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
    } catch (err) {
      let errorMessage = "Failed to add CROS-3 form";
      if (typeof err === "string") {
        errorMessage = err;
      } else if (typeof err === "object" && err !== null) {
        errorMessage = Object.values(err).flat().join("\n");
      }
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />
        <div className="card">
          <div className="card-header border-bottom">
            <h5 className="mb-0">Add CROS-3 Questionnaire</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <Cros3FormUI
                formData={formData}
                setFormData={setFormData}
                errors={errors}
              />
              <div className="row px-4 pb-4">
                <div className="col-md-2 ms-auto">
                  <button type="submit" className="btn btn-primary w-100">
                    <i className="ri-save-3-line me-1"></i> Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddCros3Form;
